import React from 'react';

import Calculator from '../Components/Calculator';

const CalculatorPage = () => (
  <div className="calculator-page">
    <h2 className="calculator-text">
      Let&apos;s do some math!
    </h2>
    <Calculator />
  </div>
);

export default CalculatorPage;
